module.exports = __webpack_public_path__ + "static/media/AVK01929.2413d9a2.jpg";